// extracted by mini-css-extract-plugin
module.exports = {"heading":"PageOneHeading_heading__3JYk-"};